import { Action, ActionType } from "@redux/actionTypes/cogsEstimationActionType";
import { Reducer } from "redux";

export interface IcogsEstimationListState {
  cogsDetailsByID: CogsEstimationForm[];
}

export interface CogsEstimationForm {
  projectId: number;
  projectName: string;
  apisource: string;
  apipricePerKg: number;
  ksmPricePerKg: number;
  status: string;
  apisaltAssay: number;
  ksmSaltAssay: number;
  isApiksmDevelopment: string;
  ksmCurrencyId: number | string;
  apicurrencyId: number | string;
  cogsEstimationStatus: cogsEstimationStatus;
  projectDetailsByBusinessUnits: projectDetails[];
}
export interface cogsEstimationStatus {
  projectId: number;
  status: string;
}

export interface projectDetails {
  dosageForm: string;
  packStyle: string;
  strength: number;
  strengthUnit: string;
  packTradeDress: string;
  packSize: string;
  cogsEstimation: {
    cogsEstimationId?: number;
    detailId?: number;
    batchSize: number;
    yieldPercentage: number;
    batchOutputInPacks: number;
    conversionPerUnit: number;
    api: number;
    excipients: string;
    pm: string;
    conversion: number;
    exWorks: number;
    inwardFreight: number;
    testingAndRelease: number;
    landedCogs: number;
    currencyId: number | string;
    iWfreigth: number;
    testing: number;
  };
  ksmCogsEstimation: {
    ksmCogsEstimationId?: number;
    detailId?: number;
    batchSize: number;
    yieldPercentage: number;
    batchOutputInPacks: number;
    conversionPerPtd: number;
    ksm: number;
    otherRm: string;
    pm: string;
    ccpc: number;
    exWorks: number;
    currencyId: number | string;
  };
}

const initialState = {
  cogsDetailsByID: [],
};

export const cogsEstimationReducer: Reducer<IcogsEstimationListState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.COGS_DETAILS_BY_ID:
      return {
        ...state,
        cogsDetailsByID: action.payload,
      };
    default:
      return state;
  }
};
